require('./bizumConfirmationCodeValidationStep.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utils
const { formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @commons
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { InputSafe } = require('commonsComponents/inputSafe');
const { OKButton } = require('components/commons/OKButton/OKButton');
const {SMS_CODE_PORTABILITY_REGEX} = require('constants/contactCenter/regex');

class BizumConfirmationCodeValidationStep extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isInvalid: false
        }

        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleResend = this.handleResend.bind(this);
    }
    handleTextChange(e) {
        const isSmsCodeInvalid = !SMS_CODE_PORTABILITY_REGEX.test(e.target.value);
        this.setState({ isInvalid: isSmsCodeInvalid});
        this.props.onTextChange(e.target.value,isSmsCodeInvalid);
    }

    handleResend() {
        this.props.onResendClick();
    }

    render() {
        const { children, isDisabled, inputValue, isCodeValid } = this.props;
        const wizardTitle = formatText('portability-codeAlreadySentTitle');
        const infoTextCodeSent1 = formatText('portability-codeAlreadySentText1');
        const infoTextCodeSent2 = formatText('portability-codeAlreadySentText2');
        const infoTextCodeNotArrived1 = formatText('portability-codeNotArrived1');
        const infoTextCodeNotArrived2 = formatText('portability-codeNotArrived2');
        const infoTextCodeWrong1 = formatText('portability-codeWasWrong1');
        const infoTextCodeWrong2 = formatText('portability-codeWasWrong2');
        const errorMessage = formatText('portability-codeErrorMessage');
        let buttonLabel = isCodeValid ? infoTextCodeNotArrived2 : infoTextCodeWrong1;

        return (
            <div>
                <div className="bizum-confirmation-validation-step__data">
                    <div className="bizum-confirmation-validation-step__heading">
                        <i className="bizum-confirmation-validation-step__success-icon"></i>
                        <div className="bizum-confirmation-validation-step__wizard-title">
                            <OKBoxTitle value={wizardTitle}
                                isNotSeparator={true}>
                            </OKBoxTitle>
                        </div>
                    </div>
                    <div className="bizum-confirmation-validation-step__info-box">
                        <BlockInfo>
                            <p>{infoTextCodeSent1}</p><p>{infoTextCodeSent2}</p>
                        </BlockInfo>
                    </div>
                    <div className="bizum-confirmation-validation-step__form-box">
                        <div className="bizum-confirmation-validation-step__input-box">
                            <InputSafe
                                disabled={isDisabled}
                                id="bizumConfirmationCode"
                                name="bizumcode"
                                type="text"
                                onChange={this.handleTextChange}
                                errorState={!isCodeValid || this.state.isInvalid}
                                errorMessage={this.state.isInvalid && errorMessage}
                                value={inputValue}
                            />
                        </div>
                        <div className="bizum-confirmation-validation-step__help-box">
                            <p className="bizum-confirmation-validation-step__parragraph">{isCodeValid && infoTextCodeNotArrived1}</p>
                            <p className="bizum-confirmation-validation-step__parragraph">
                                <OKButton
                                    modifier="link-inline"
                                    onClick={this.handleResend}
                                    id="btn_bizum_resend"
                                >
                                    {buttonLabel}
                                </OKButton>
                            </p>
                            <p className="bizum-confirmation-validation-step__parragraph">{!isCodeValid && infoTextCodeWrong2}</p>
                        </div>
                    </div>
                </div>
                <div className="bizum-confirmation-wizard-step__buttons">
                    {children}
                </div>
            </div>
        );
    }
}

BizumConfirmationCodeValidationStep.propTypes = {
    children: PropTypes.object,
    isDisabled: PropTypes.bool,
    inputValue: PropTypes.string,
    isCodeValid: PropTypes.bool,
    onTextChange: PropTypes.func,
    onResendClick: PropTypes.func
};

module.exports = BizumConfirmationCodeValidationStep;
